import { styled } from '@mui/material'

export const ButtonContainer = styled('div')`
    flex-direction: column;
    display: flex;
    justify-content: flex-end;
`
